import './progress.scss';

import Component from '../component/component';

export default class Progress extends Component {
    static initSelector: string = '.js-progress';

    public bar: HTMLElement;
    public valueSelector: HTMLElement;
    public reward: NodeListOf<HTMLElement>;
    public rewardsBar: HTMLElement;
    public rewardCount: number;

    public value: number = 0;
    public min: number = 0;
    public max: number = 100;
    public position: number = 50;
    public color: string = '#f58220';

    constructor(target: HTMLElement) {
        super(target);

        this.bar = this.element.querySelector('.progress__complete');
        this.valueSelector = this.element.querySelector('.progress__complete-value');
        this.reward = this.element.querySelectorAll('.progress__reward-dot');
        this.rewardsBar = this.element.querySelector('.progress__bar-rewards');

        const value: string = this.bar.dataset.completeValue;

        if (value.indexOf(',') > 0) {
            value.replace(',', '.');
        }

        this.value = parseFloat(value);
        this.color = window.getComputedStyle(this.bar).backgroundColor;
        this.min = parseInt(this.bar.dataset.completeMin);
        this.max = parseInt(this.bar.dataset.completeMax);
        this.position = ((this.value - 1) / (this.max - 1) * 100);
        this.rewardCount = this.reward.length;

        this.init();
    }

    public static getPositionAtCenter(element: HTMLElement): ICoordinates {
        const position: IBoundingBox = element.getBoundingClientRect();

        return {
            x: position.left + position.width / 2,
            y: position.top + position.height / 2,
        };
    }

    public static getPositionAtLeft(element: HTMLElement): ICoordinates {
        const position: IBoundingBox = element.getBoundingClientRect();

        return {
            x: position.left,
            y: position.top + position.height / 2,
        };
    }

    public static getDistanceBetweenElements(a: HTMLElement, b: HTMLElement): number {
        const aPosition: ICoordinates = Progress.getPositionAtLeft(a);
        const bPosition: ICoordinates = Progress.getPositionAtCenter(b);

        Math.hypot = (x: number, y: number): number => Math.sqrt(x * x + y * y);

        return Math.hypot(aPosition.x - bPosition.x, aPosition.y - bPosition.y);
    }

    calculateRewardsWidth(): void {
        const parentWidth: number = this.element.clientWidth;
        const sectionWidth: number = (parentWidth - 72) / (this.max);

        if (!this.element.classList.contains('progress--default')) {
            (this.element.querySelector('.progress__inner') as HTMLElement).style.maxWidth = `${parentWidth - 72 - sectionWidth + 11}px`;
        }
    }

    init(): void {
        const a: HTMLElement = this.element.querySelector('.progress__inner');
        const b: HTMLElement = this.reward[this.value - 1];

        if (a && b) {
            const width: number = parseFloat(getComputedStyle(this.rewardsBar, null).width.replace('px', ''));

            this.position = (Progress.getDistanceBetweenElements(a, b) / width) * 100;
        }

        this.bar.style.maxWidth = this.position + '%';

        if (this.valueSelector) {
            this.valueSelector.style.left = this.position + '%';
        }

        if (this.value === this.max) {
            if (this.valueSelector) {
                this.valueSelector.style.display = 'none';
            }
            this.bar.style.display = 'none';
            this.reward.forEach((element: HTMLElement) => {
                element.style.backgroundColor = this.color;
            });
            this.element.style.backgroundColor = this.color;
        } else if (this.value === this.min) {
            if (this.valueSelector) {
                this.valueSelector.style.display = 'none';
            }
        } else {
            window.setTimeout(() => {
                if (this.valueSelector) {
                    this.valueSelector.classList.remove('h-hidden');
                }
            }, 900);

            this.reward.forEach((element: HTMLElement, index: number) => {
                if (index < this.value) {
                    window.setTimeout(() => {
                        element.style.backgroundColor = this.color;
                    }, (900 / this.value) * index);
                }
            });
        }

        this.calculateRewardsWidth();
        window.addEventListener('resize', this.calculateRewardsWidth.bind(this));
    }
}

interface ICoordinates {
    x?: number;
    y?: number;
}

interface IBoundingBox {
    width: number;
    height: number;
    top: number;
    left: number;
}
